import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

Vue.use(Router)

// 公共路由（所有人可访问）
const constantRoutes = [
  {
    path: '/',
    name: 'LayoutView',
    component: () => import('@/views/Layout.vue'),
    redirect: '/Home',
    children: [
      {
        path: '/Home',
        name: 'HomeView',
        component: () => import('@/views/Home.vue'),
        meta: { title: '首页', icon: 'el-icon-s-home', roles: ['regular', 'payuser', 'admin'] }
      },
      {
        path: '/Company',
        name: 'CompanyView',
        component: () => import('@/views/ordinaryPage/Company.vue'),
        meta: { title: '公司信息', icon: 'el-icon-office-building', roles: ['regular', 'payuser'] }
      },
      {
        path: '/IconPage',
        name: 'IconView',
        component: () => import('@/views/ordinaryPage/IconPage.vue'),
        meta: { title: '模板', icon: 'el-icon-star-on', roles: ['regular', 'payuser'] }
      },
      {
        path: '/Banner',
        name: 'BannerView',
        component: () => import('@/views/ordinaryPage/Banner.vue'),
        meta: { title: '轮播图', icon: 'el-icon-picture', roles: ['regular', 'payuser'] }
      },
      {
        path: '/Product',
        name: 'ProductView',
        component: () => import('@/views/ordinaryPage/Product.vue'),
        meta: { title: '产品', icon: 'el-icon-tickets', roles: ['payuser'] }
      },
      {
        path: '/ProductGroup',
        name: 'ProductGroupView',
        component: () => import('@/views/ordinaryPage/ProductGroup.vue'),
        meta: { title: '产品分类', icon: 'el-icon-document-copy', roles: ['payuser'] }
      },
      {
        path: '/Role',
        name: 'RoleView',
        component: () => import('@/views/adminPage/Role.vue'),
        meta: { title: '角色管理', icon: 'el-icon-s-tools', roles: ['admin'] }
      },
      {
        path: '/User',
        name: 'UserView',
        component: () => import('@/views/adminPage/User.vue'),
        meta: { title: '用户管理', icon: 'el-icon-user', roles: ['admin'] }
      },
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login.vue'),
    meta: { title: '登录' }
  },
  { path: '*', redirect: '/' }
]

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

// 防止连续点击多次路由报错
let routerPush = Router.prototype.push
let routerReplace = Router.prototype.replace
// push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(err => err)
}
// replace
Router.prototype.replace = function push(location) {
  return routerReplace.call(this, location).catch(err => err)
}

router.beforeEach((to, from, next) => {
  // 放行静态资源
  const staticExtensions = ['.png', '.jpg', '.jpeg', '.webp', '.gif', '.svg', '.css', '.js', '.ico', '.woff', '.woff2', '.ttf']
  if (staticExtensions.some(ext => to.path.toLowerCase().endsWith(ext))) {
    next(); return
  }
  const isLoginPage = to.path === '/login'
  // 跳转页面的标题
  if (isLoginPage) document.title = '登录'
  else document.title = '启铭名片系统'

  // 是否登录
  const token = store.getters.getAccessToken
  if (!token && !isLoginPage) {
    next({ path: '/login', query: { redirect: to.fullPath } })
    return
  }
  if (token && isLoginPage) {
    next({ path: '/' })
    return
  }
  // 已登录 — 检查角色权限（统一转为小写比较）
  const userRole = (store.getters.getUserRole || 'regular').toLowerCase()
  const routeRoles = to.meta?.roles
  if (routeRoles && !routeRoles.includes(userRole)) {
    // 无权限，重定向到首页
    next({ path: '/' })
    return
  }
  next()
})

export default router
